import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const DisplayAddressModalButtons = ({
  toggleCheckboxStatus,
  closeNextModal
}) => {
  return (
    <>
      <div slot="action-zone" className="tax-modal-btn-container">
        <MFBeaconButton
          noButtonMargin
          variant="tertiary"
          type="button"
          id="notSubjectToWithholdingBtn"
          data-name={generateGeneralTestID(
            'Review',
            'NotSubjectToWithholdingButton'
          )}
          onClick={() => {
            toggleCheckboxStatus(false);
            modalCloseNextModalHandler(closeNextModal);
          }}
          label="No, I am not subject to withholding"
        />
        <MFBeaconButton
          noButtonMargin
          type="button"
          variant="primary"
          id="subjectToWithholdingBtn"
          data-name={generateGeneralTestID(
            'Review',
            'SubjectToWithholdingButton'
          )}
          onClick={() => {
            toggleCheckboxStatus(true);
            modalCloseNextModalHandler(closeNextModal);
          }}
          label="Yes, I am subject to withholding"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

const TaxpayerCertificationsModal = ({ toggleCheckboxStatus }) => {
  const { closeNextModal } = useContext(FlowContext);

  return (
    <>
      <MFBeaconModal id="taxCertificationModal" removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            id="taxCertificationModalCloseIcon"
            data-name={generateGeneralTestID(
              'Review',
              'TaxCertificationCloseModalButton'
            )}
            variant="tertiary"
            onClick={() => {
              toggleCheckboxStatus(false);
              modalCloseNextModalHandler(closeNextModal);
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">
          Has the IRS told you that you are subject to backup withholding?
        </div>
        <div className="beacon-modal__description">
          If you are subject to backup withholding, T. Rowe Price will withhold
          tax on all distributions, capital gains, and dividends for this
          account.
        </div>
        <DisplayAddressModalButtons
          toggleCheckboxStatus={toggleCheckboxStatus}
          closeNextModal={closeNextModal}
        />
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default TaxpayerCertificationsModal;
